<template>
    <div class="col-lg-12">
        <div class="apprentice-simple-card">

                <div class="title">
                    <h5>{{$t('common.students')}}</h5>
                </div>

                <p>{{$t('group.select_students_for_group')}}</p>

                <div v-if="error">
                    <b-alert show variant="danger">
                        {{StudentErrorText}}
                    </b-alert>
                </div>

                <br><br>

                <design-2021-apprentice-data-table :items="students" :fields="fields">

                    <template v-slot:cell(actions)="data">

                        <b-button
                            variant="primary-icon-only"
                            @click="addUser(data.item.model)"
                            :title="$t('assignment.add_student')"
                            v-b-tooltip.hover
                            class="btn-add btn-show-skill-tree remove-icon-margin"
                        >
                        </b-button>
                    </template>

                </design-2021-apprentice-data-table>
            </div>
        </div>

</template>

<script>

export default {
    name: "design-2021-group-pair-student-component",
    props: [
        'groupIn',
        'studentsIn',
        'selectedStudentsIn',
        'error'
    ],
    data(){
        return{
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name')
                },
                {
                    key: 'actions',
                    label: this.$t('common.choose')
                }
            ]
        }
    },
    computed: {
        students() {
            const selected_ids = this.selectedStudentsIn.map((student) => student.id)
            let studentsArray = this.studentsIn.filter((student) => !selected_ids.includes(student.user.id))
            return studentsArray.map(student => {
                return {
                    id: student.id,
                    name: student.user.full_name,
                    model: student,
                }
            })
        },
        StudentErrorText(){
            const min = this.groupIn.group_pair_options.partner_min;
            const max = this.groupIn.group_pair_options.partner_max;

            if(min !== null && max === null){
                return 'Het aantal leerlingen moet minimaal ' + min + ' zijn.';
            }

            if(min === null && max !== null){
                return 'Het aantal leerlingen moet maximaal ' + max + ' zijn.';
            }

            if(min === max){
                return 'Het aantal leerlingen moet ' + max + ' zijn.';
            }

            return 'Het aantal leerlingen moet tussen de ' + min + ' en ' + max + ' zitten.';
        },
    },
    methods:{
        addUser(user){
            this.$emit('add-student', user);
        },
    },
}
</script>

<style scoped lang="scss">
    .actions {
        display: flex;
        align-items: center;

        button:not(:last-child){
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
</style>
